/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.permissionsmanagement.accessrequest.rpc.AccessRequestRpc
 */
import * as References from './AccessRequestRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.permissionsmanagement.accessrequest.rpc.AccessRequestRpc#requestAccess
 */
export const REQUEST_ACCESS_MUTATION_FIELD_NAME = 'com_hubspot_permissionsmanagement_accessrequest_rpc_AccessRequestRpc_requestAccess';
export const REQUEST_ACCESS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: REQUEST_ACCESS_MUTATION_FIELD_NAME,
  args: ['scopesRequested', 'usersToNotifyForAccess', 'appLocation', 'customMessage', 'requireAnyScope'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.requestAccessRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.permissionsmanagement.accessrequest.rpc.AccessRequestRpc#getPortalNotificationSettings
 */
export const GET_PORTAL_NOTIFICATION_SETTINGS_QUERY_FIELD_NAME = 'com_hubspot_permissionsmanagement_accessrequest_rpc_AccessRequestRpc_getPortalNotificationSettings';
export const GET_PORTAL_NOTIFICATION_SETTINGS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PORTAL_NOTIFICATION_SETTINGS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getPortalNotificationSettingsRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.permissionsmanagement.accessrequest.rpc.AccessRequestRpc#setPortalNotificationSettings
 */
export const SET_PORTAL_NOTIFICATION_SETTINGS_MUTATION_FIELD_NAME = 'com_hubspot_permissionsmanagement_accessrequest_rpc_AccessRequestRpc_setPortalNotificationSettings';
export const SET_PORTAL_NOTIFICATION_SETTINGS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SET_PORTAL_NOTIFICATION_SETTINGS_MUTATION_FIELD_NAME,
  args: ['notifyUsersOnPermissionChange'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.setPortalNotificationSettingsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.permissionsmanagement.accessrequest.rpc.AccessRequestRpc#queryAccessRequestByLocation
 */
export const QUERY_ACCESS_REQUEST_BY_LOCATION_QUERY_FIELD_NAME = 'com_hubspot_permissionsmanagement_accessrequest_rpc_AccessRequestRpc_queryAccessRequestByLocation';
export const QUERY_ACCESS_REQUEST_BY_LOCATION_QUERY = /* #__PURE__ */registerQuery({
  fieldName: QUERY_ACCESS_REQUEST_BY_LOCATION_QUERY_FIELD_NAME,
  args: ['appLocationId'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.queryAccessRequestByLocationRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.permissionsmanagement.accessrequest.rpc.AccessRequestRpc#queryAccessRequestsByUserId
 */
export const QUERY_ACCESS_REQUESTS_BY_USER_ID_QUERY_FIELD_NAME = 'com_hubspot_permissionsmanagement_accessrequest_rpc_AccessRequestRpc_queryAccessRequestsByUserId';
export const QUERY_ACCESS_REQUESTS_BY_USER_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: QUERY_ACCESS_REQUESTS_BY_USER_ID_QUERY_FIELD_NAME,
  args: ['userId'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.queryAccessRequestsByUserIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.permissionsmanagement.accessrequest.rpc.AccessRequestRpc#rejectAccessRequest
 */
export const REJECT_ACCESS_REQUEST_MUTATION_FIELD_NAME = 'com_hubspot_permissionsmanagement_accessrequest_rpc_AccessRequestRpc_rejectAccessRequest';
export const REJECT_ACCESS_REQUEST_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: REJECT_ACCESS_REQUEST_MUTATION_FIELD_NAME,
  args: ['accessRequestId'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.rejectAccessRequestRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});